'use client';
import Button from '@/app/components/ui/Button';
import { useWhatsAppLink } from '@/app/hooks/useWhatsAppLink';

export default function ProblemSection() {
  const getWhatsAppLink = useWhatsAppLink();

  const handleDiagnostico = () => {
    const link = getWhatsAppLink();
    window.open(link, '_blank');
  }

  return (
    <section id="problems" className="w-full bg-[#02020c] relative">
      <div className="relative w-full flex flex-col">
        {/* Background Image */}
        <img
          src="/images/img_group_90.png"
          alt=""
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Content Overlay */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-12 lg:py-24 flex flex-col items-center">
          <div className="flex flex-col items-center w-full">
              {/* Main Problem Statement */}
              <h2 
                className="text-3xl md:text-5xl lg:text-[64px] font-normal leading-tight text-center w-full max-w-4xl"
                style={{ fontFamily: 'Raleway' }}
              >
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">Se você </span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent font-semibold italic">ainda</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"> não usa </span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent font-bold italic">IA</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"> no seu </span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent font-semibold italic">negócio</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">, sinto em dizer... Mas a </span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent font-semibold italic">concorrência</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"> vai te engolir.</span>
              </h2>

              {/* Supporting Text */}
              <div className="flex flex-col gap-[20px] sm:gap-[30px] lg:gap-[40px] w-full">
                <p 
                  className="text-[13px] sm:text-[19px] lg:text-[26px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] pr-[24px] sm:pr-[36px] lg:pr-[48px] mt-[20px] sm:mt-[30px] lg:mt-[40px]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  <span>O mercado está cada vez mais </span>
                  <span className="font-semibold italic">imediatista</span>
                  <span>, e o seu negócio </span>
                  <span className="font-semibold italic">PRECISA </span>
                  <span>acompanhar se quiser chegar no </span>
                  <span className="font-semibold italic">topo</span>
                  <span> ou se </span>
                  <span className="font-semibold italic">manter lá.</span>
                </p>

                <p 
                  className="text-[13px] sm:text-[19px] lg:text-[26px] font-light leading-[16px] sm:leading-[23px] lg:leading-[31px] text-center text-[#b7c3d7] pr-[36px] sm:pr-[54px] lg:pr-[72px] mt-[15px] sm:mt-[22px] lg:mt-[30px]"
                  style={{ fontFamily: 'Raleway' }}
                >
                  <span>Se você ainda usa o modelo </span>
                  <span className="font-semibold italic">tradicional</span>
                  <span> de comercial, </span>
                  <span>o seu time</span>
                  <span>...</span>
                </p>
              </div>

              {/* Problem List */}
              <div className="flex flex-col items-center w-full max-w-4xl mt-12 lg:mt-16">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-col lg:items-center gap-4 w-full">
                  {/* Problem Item 1 */}
                  <div className="flex items-center justify-start w-full bg-[#0a2d395b] border border-[#334668] rounded-[36px] py-[15px] sm:py-[22px] lg:py-[30px] px-[16px] sm:px-[24px] lg:px-[32px]">
                    <img
                      src="/images/img_x.svg"
                      alt="Problem"
                      className="w-[24px] h-[24px] sm:w-[36px] sm:h-[36px] lg:w-[48px] lg:h-[48px]"
                    />
                    <span 
                      className="text-[16px] sm:text-[23px] lg:text-[30px] font-normal leading-[20px] sm:leading-[28px] lg:leading-[36px] text-left text-[#ffffff] ml-[10px] sm:ml-[15px] lg:ml-[20px]"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      Não consegue atender nem 90% do leads
                    </span>
                  </div>

                  {/* Problem Item 2 */}
                  <div className="flex items-center justify-start w-full bg-[#0a2d395b] border border-[#334668] rounded-[36px] py-[15px] sm:py-[22px] lg:py-[30px] px-[16px] sm:px-[24px] lg:px-[32px]">
                    <img
                      src="/images/img_x.svg"
                      alt="Problem"
                      className="w-[24px] h-[24px] sm:w-[36px] sm:h-[36px] lg:w-[48px] lg:h-[48px]"
                    />
                    <span 
                      className="text-[16px] sm:text-[23px] lg:text-[30px] font-normal leading-[20px] sm:leading-[28px] lg:leading-[36px] text-left text-[#ffffff] ml-[10px] sm:ml-[15px] lg:ml-[20px]"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      Não é agil p/ atender como precisa
                    </span>
                  </div>

                  {/* Problem Item 3 */}
                  <div className="flex items-center justify-start w-full bg-[#0a2d395b] border border-[#334668] rounded-[36px] py-[15px] sm:py-[22px] lg:py-[30px] px-[16px] sm:px-[24px] lg:px-[32px]">
                    <img
                      src="/images/img_x.svg"
                      alt="Problem"
                      className="w-[24px] h-[24px] sm:w-[36px] sm:h-[36px] lg:w-[48px] lg:h-[48px]"
                    />
                    <span 
                      className="text-[16px] sm:text-[23px] lg:text-[30px] font-normal leading-[20px] sm:leading-[28px] lg:leading-[36px] text-left text-[#ffffff] ml-[10px] sm:ml-[15px] lg:ml-[20px] self-end"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      Tem carga horária limitada entre 8h e 18h
                    </span>
                  </div>

                  {/* Problem Item 4 */}
                  <div className="flex items-center justify-start w-full bg-[#0a2d395b] border border-[#334668] rounded-[36px] py-[15px] sm:py-[22px] lg:py-[30px] px-[16px] sm:px-[24px] lg:px-[32px]">
                    <img
                      src="/images/img_x.svg"
                      alt="Problem"
                      className="w-[24px] h-[24px] sm:w-[36px] sm:h-[36px] lg:w-[48px] lg:h-[48px]"
                    />
                    <span 
                      className="text-[16px] sm:text-[23px] lg:text-[30px] font-normal leading-[20px] sm:leading-[28px] lg:leading-[36px] text-left text-[#ffffff] ml-[10px] sm:ml-[15px] lg:ml-[20px]"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      Tem custo elevado entre salário + comissão
                    </span>
                  </div>
                </div>

                {/* Result Text */}
                <div className="flex flex-col items-center gap-[20px] sm:gap-[30px] lg:gap-[40px] w-[86%] mt-[30px] sm:mt-[45px] lg:pt-[60px] pr-[11px] sm:pr-[16px] lg:pr-[22px]">
                  <p 
                    className="text-[13px] sm:text-[19px] lg:text-[26px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    O resultado disso? Seu investimento em tráfego pode ser 50% menos eficiente... E quem agradece? Seu concorrente.
                  </p>

                  <p 
                    className="text-[13px] sm:text-[19px] lg:text-[25px] font-normal leading-[18px] sm:leading-[27px] lg:leading-[36px] text-center text-[#b7c3d7] w-full"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    É um jogo de eficiência, quem for mais rápido e eficiente para o lead, leva. Quem saciar o imediatismo do mercado, LEVA.
                  </p>
                </div>

                {/* CTA Button */}
                <div className="mt-[20px] sm:mt-[30px] lg:mt-[40px] w-full flex justify-center">
                  <Button
                    onClick={handleDiagnostico}
                    text_font_size="text-lg"
                    text_font_family="Raleway"
                    text_font_weight="font-normal"
                    text_line_height="leading-base"
                    text_text_align="center"
                    text_color="text-primary-background"
                    fill_background_color="bg-button-primary"
                    border_border_radius="rounded-xl"
                    padding="py-[14px] px-[34px] pr-[56px]"
                    className="italic flex items-center gap-[10px] hover:opacity-90 transition-opacity duration-200 group"
                  >
                    <span className="group-hover:text-[#02020c] transition-colors duration-200">QUERO FAZER UM DIAGNÓSTICO</span>
                    <img 
                      src="/images/img_group_84.svg" 
                      alt="Arrow" 
                      className="w-[22px] h-[22px] group-hover:invert transition-all duration-200" 
                    />
                  </Button>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>
  )
}